import { ChevronRight, Search } from '@mui/icons-material';
import { Box, CircularProgress, IconButton, Stack, Typography } from '@mui/material';

import CloseIcon from 'src/assets/images/icons/CloseButtonSVG';
import { CompanyLookupResponse } from 'src/pages/AddPartnerPage/steps/step2_PartnerInformation';

interface CompanyListProps {
    selectedCompanyNumber: number;
    isFetchingReport?: boolean;
    onClose: () => void;
    data: CompanyLookupResponse[];
    onSelectCompany: (el?: CompanyLookupResponse) => void;
}

const CompanyList = ({
    selectedCompanyNumber,
    isFetchingReport,
    onClose,
    data,
    onSelectCompany,
}: CompanyListProps) => {
    return (
        <>
            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                    borderTopLeftRadius: '16px',
                    borderTopRightRadius: '16px',
                    background: `linear-gradient(90deg, #FF8008 0%, #FFC837 100%)`,
                    padding: '24px',
                }}
            >
                <Box display="flex" alignItems="center" color="#FFFAE5">
                    <Search color="inherit" />
                    <Typography fontSize="24px" color="#FFFAE5" marginLeft="14px">
                        Search
                    </Typography>
                </Box>
                <IconButton data-testid={'company-list-close'} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </Box>
            <Box
                bgcolor="white"
                sx={{
                    borderBottomLeftRadius: '16px',
                    borderBottomRightRadius: '16px',
                }}
            >
                <Box padding="24px" borderBottom="1px solid #DADADA">
                    Search and filters
                </Box>
                <Box padding="24px">
                    <Typography color="#686867" fontSize="20px" lineHeight="40px">
                        {data.length ? 'Results found' : '0 Result Found'}
                    </Typography>
                    <Typography color="#333333" fontSize="10px" lineHeight="28px">
                        The following results were returned
                    </Typography>
                    <Box height="2px" width="100%" bgcolor="#F18F34" marginBottom="24px" />
                    <Stack
                        spacing={4}
                        width="100%"
                        sx={{ overflowY: 'hidden', padding: '10px 0px 20px 0' }}
                    >
                        {(data || []).map((el) => {
                            return (
                                <Box
                                    key={`${el.companyName}`}
                                    sx={{ display: 'block', height: 'auto' }}
                                >
                                    <Box
                                        key={el.companyName}
                                        borderRadius="16px"
                                        overflow="hidden"
                                        display="flex"
                                        width="100%"
                                    >
                                        <Box
                                            width="100%"
                                            padding="24px"
                                            border="1px solid #DADADA"
                                            borderRight="0px"
                                            sx={{
                                                borderTopLeftRadius: '16px',
                                                borderBottomLeftRadius: '16px',
                                            }}
                                        >
                                            <Typography
                                                color="#434341"
                                                fontSize="20px"
                                                lineHeight="28.6px"
                                            >
                                                {el.companyName}
                                            </Typography>
                                            <Typography
                                                fontSize="14px"
                                                color="#434341"
                                                lineHeight="20px"
                                                marginTop="8px"
                                            >
                                                {el.registrationNumber}
                                                <br />
                                                {el.companyTypeDescription}
                                            </Typography>
                                        </Box>
                                        <Box
                                            bgcolor="#F18F34"
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            padding="20px"
                                            onClick={() => {
                                                return onSelectCompany(el);
                                            }}
                                            data-testid={'company-list-select'}
                                            sx={{ cursor: 'pointer' }}
                                        >
                                            {isFetchingReport &&
                                            selectedCompanyNumber === el.registrationNumber ? (
                                                        <CircularProgress
                                                            size={34}
                                                            sx={{ color: 'white' }}
                                                        />
                                                    ) : (
                                                        <ChevronRight
                                                            sx={{ color: 'white' }}
                                                            fontSize="large"
                                                        />
                                                    )}
                                        </Box>
                                    </Box>
                                </Box>
                            );
                        })}
                    </Stack>
                </Box>
            </Box>
        </>
    );
};
export default CompanyList;
